import React, { ReactNode, useEffect, useMemo } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Typography, Button } from '@mui/material';

import { PATH_DASHBOARD } from '../../routes/paths';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { StyledTopAlert } from './styles';
import usePage from 'src/hooks/usePage';
import { CubesIcon } from 'src/theme/overrides/CustomIcons';

//
//

const TopAlertMessage = () => {
  const { pathname } = useLocation();
  const { isOpenAlert, setIsOpenAlert } = usePage();
  const { subscriptionsAreLoading, subscriptions } = useSubscriptions();

  const onPlansPage = useMemo(() => pathname.includes(PATH_DASHBOARD.account.plans), [pathname])

  useEffect(() => {
    if (!subscriptionsAreLoading) {
      if (!subscriptions?.currentSubscriptions?.length && !onPlansPage) {
        setIsOpenAlert(true);
      } else {
        setIsOpenAlert(false);
      }
    }
  }, [subscriptionsAreLoading, setIsOpenAlert, onPlansPage, subscriptions?.currentSubscriptions?.length])

  const TopAlertContainer = ({ children }: { children: ReactNode }) => {
    return isOpenAlert ?
      <StyledTopAlert
        onClose={() => setIsOpenAlert(false)}
        id='subscription-status-alert-message'
      >
        {children}
      </StyledTopAlert> : null
  }

  const ActionButton = () => (
    <Button
      component={RouterLink}
      to={PATH_DASHBOARD.account.plans}
      variant="contained"
      color='carbon'
      className='brandcube'
      endIcon={<CubesIcon size='small' />}
    >
      Subscribe today
    </Button>
  );

  return (
    <>
      {!subscriptions?.currentSubscriptions?.length && isOpenAlert && (
        <TopAlertContainer>
          <Typography>
            <b>You’re currently on a free account.</b>{' '}
            Activate on one of our paid plans to get access to premium features.
          </Typography>
          <ActionButton />
        </TopAlertContainer>
      )}
    </>
  );
};

export default TopAlertMessage;
